export const TeamPermissions = {
	participant: 1,
	admin: 2
}